import React from "react";
import MemoForm from "../Form/MemoForm";

function Main() {
  let pageHeader = "СТАНДАРТНЫЙ РАСЧЕТ";
  return (
    <main
      className="container site-padding-h site-padding-v"
      style={{ paddingBottom: "60px" }}
    >
      <h1 className="page_header">{pageHeader}</h1>
      <MemoForm/>
    </main>
  );
}

export default Main;
